var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.793,
    height: 27.773,
    viewBox: "0 0 30.793 27.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-g-translate",
    "data-name": "Icon material-g-translate",
    d: "M30.713,7.166H16.672L15.317,3H6.079A2.949,2.949,0,0,0,3,5.777V23.83a2.949,2.949,0,0,0,3.079,2.777H16.857l1.54,4.166H30.713A2.949,2.949,0,0,0,33.793,28V9.943A2.949,2.949,0,0,0,30.713,7.166ZM10.96,20.483c-3.464,0-6.3-2.541-6.3-5.68s2.818-5.68,6.3-5.68a6.458,6.458,0,0,1,4.219,1.486l.108.083-1.894,1.639-.092-.069a3.541,3.541,0,0,0-2.34-.819A3.533,3.533,0,0,0,7.3,14.8a3.533,3.533,0,0,0,3.664,3.361,3.128,3.128,0,0,0,3.264-2.027h-3.4V13.984H16.9l.015.1a3.943,3.943,0,0,1,.077.847C17,18.192,14.516,20.483,10.96,20.483Zm9.284-2.375a13.944,13.944,0,0,0,1.832,2.361l-.831.736Zm1.186-1.055H19.905l-.477-1.444h6.143a10.368,10.368,0,0,1-2.4,3.8,12.721,12.721,0,0,1-1.74-2.361ZM32.253,28a1.474,1.474,0,0,1-1.54,1.389H19.936l3.079-2.777L21.768,22.76l1.416-1.278,4.126,3.735L28.435,24.2l-4.172-3.722a11.825,11.825,0,0,0,2.956-4.874h1.955V14.165h-5.6V12.721h-1.6v1.444H18.951l-1.817-5.61h13.58a1.474,1.474,0,0,1,1.54,1.389Z",
    transform: "translate(-3 -3)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.b0c0005ce12358ae6ebe7c5efa5c9c29.svg";
export { ForwardRef as ReactComponent };